/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface RepresentantDoublonSearch
 */
export interface RepresentantDoublonSearch {
    /**
     * 
     * @type {string}
     * @memberof RepresentantDoublonSearch
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepresentantDoublonSearch
     */
    prenom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepresentantDoublonSearch
     */
    numeroNational?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RepresentantDoublonSearch
     */
    dateNaissance?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof RepresentantDoublonSearch
     */
    nationalite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepresentantDoublonSearch
     */
    codesexe?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepresentantDoublonSearch
     */
    adresseNaissance?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RepresentantDoublonSearch
     */
    idpersonne?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepresentantDoublonSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof RepresentantDoublonSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof RepresentantDoublonSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RepresentantDoublonSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof RepresentantDoublonSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof RepresentantDoublonSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the RepresentantDoublonSearch interface.
 */
export function instanceOfRepresentantDoublonSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RepresentantDoublonSearchFromJSON(json: any): RepresentantDoublonSearch {
    return RepresentantDoublonSearchFromJSONTyped(json, false);
}

export function RepresentantDoublonSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepresentantDoublonSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'prenom': !exists(json, 'prenom') ? undefined : json['prenom'],
        'numeroNational': !exists(json, 'numeroNational') ? undefined : json['numeroNational'],
        'dateNaissance': !exists(json, 'dateNaissance') ? undefined : (json['dateNaissance'] === null ? null : new Date(json['dateNaissance'])),
        'nationalite': !exists(json, 'nationalite') ? undefined : json['nationalite'],
        'codesexe': !exists(json, 'codesexe') ? undefined : json['codesexe'],
        'adresseNaissance': !exists(json, 'adresseNaissance') ? undefined : json['adresseNaissance'],
        'idpersonne': !exists(json, 'idpersonne') ? undefined : json['idpersonne'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function RepresentantDoublonSearchToJSON(value?: RepresentantDoublonSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nom': value.nom,
        'prenom': value.prenom,
        'numeroNational': value.numeroNational,
        'dateNaissance': value.dateNaissance === undefined ? undefined : (value.dateNaissance === null ? null : value.dateNaissance.toISOString()),
        'nationalite': value.nationalite,
        'codesexe': value.codesexe,
        'adresseNaissance': value.adresseNaissance,
        'idpersonne': value.idpersonne,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

